import type { IConfigObj } from '@makemydeal/dr-common-utils';
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import type { ReduxMiddleware, ReduxStore, ReduxNext } from '@makemydeal/dr-shared-store';
import * as configSelectors from '../selectors/config';
import { getPresignedUploadUrl, uploadFileToS3 } from '../actions/globalPrintingSettingsActionCreators';
import {
    UPLOAD_LOGO,
    GET_PRESIGNED_UPLOAD_URL_SUCCESS,
    GET_PRESIGNED_UPLOAD_URL_FAILURE
} from '../actionTypes/globalPrintingSettingsActionTypes';
import type { DealerLogoMetadata, StateTree } from '@makemydeal/dr-dash-types';

interface PendingUpload {
    file: File;
    dealerId: number;
    metadata: DealerLogoMetadata;
    bffEndpoint: IConfigObj;
}

let pendingUpload: PendingUpload | null = null;

export const __resetPendingUploadForTesting = () => {
    pendingUpload = null;
};

export const middleware: ReduxMiddleware<StateTree> = (store: ReduxStore<StateTree>) => (next: ReduxNext) => (action: AnyFSA) => {
    next(action);
    switch (action.type) {
        case UPLOAD_LOGO: {
            const { file, dealerId, metadata } = action.payload;
            const bffEndpoint = configSelectors.getServicesBff(store.getState());
            pendingUpload = { file, dealerId, metadata, bffEndpoint };
            store.dispatch(getPresignedUploadUrl(dealerId, file.type, bffEndpoint));
            break;
        }
        case GET_PRESIGNED_UPLOAD_URL_SUCCESS: {
            if (!pendingUpload) break;
            const { file, dealerId, metadata, bffEndpoint } = pendingUpload;
            const { uploadUrl } = action.payload;
            pendingUpload = null;
            store.dispatch(uploadFileToS3(uploadUrl, file, dealerId, metadata, bffEndpoint));
            break;
        }
        case GET_PRESIGNED_UPLOAD_URL_FAILURE: {
            pendingUpload = null;
            break;
        }
    }
};
